import { __decorate } from 'tslib';
import { NgModule, InjectionToken } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let ApiModule = class ApiModule {
};
ApiModule.ɵfac = function ApiModule_Factory(t) { return new (t || ApiModule)(); };
ApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ApiModule });
ApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

const API_CONFIG = new InjectionToken('api.config');

const config = {
    host: 'http://localhost:8000'
};

/**
 * Generated bundle index. Do not edit.
 */

export { API_CONFIG, ApiModule, config };

